export const MapIcon = () => {
	return (
		<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M9.25 12.25L4.75 10.6675V1.75L9.25 3.3325M13.375 0.25C13.33 0.25 13.2925 0.25 13.255 0.25L9.25 1.825L4.75 0.25L0.52 1.675C0.3625 1.7275 0.25 1.8625 0.25 2.035V13.375C0.25 13.4745 0.289509 13.5698 0.359835 13.6402C0.430161 13.7105 0.525544 13.75 0.625 13.75C0.6625 13.75 0.7075 13.75 0.745 13.7275L4.75 12.175L9.25 13.75L13.48 12.325C13.6375 12.25 13.75 12.1375 13.75 11.965V0.625C13.75 0.525544 13.7105 0.430161 13.6402 0.359835C13.5698 0.289509 13.4745 0.25 13.375 0.25Z" fill="currentColor" />
		</svg>
	)
}
